import { CheckBoxProps, CheckBoxWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import { HeaderColumn } from '@tableau/widgets-datagrid';
import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { CheckboxState } from '../../../common/components/checkboxes/CheckboxState';
import { GroupsGridColumn } from './GroupsGrid';

export const GROUPS_GRID_HEADER_CHECKBOX_TEST_ID = 'groups-grid-header-column';

export class GroupsGridHeaderFormatter extends React.Component<HeaderColumn.HeaderFormatterProps, {}> {

  private tooltipContent(checkboxState: CheckboxState): JSX.Element {
    return <span>{checkboxState === CheckboxState.checked ? Messages.deselectAll() : Messages.selectAll() }</span>;
  }

  private renderCheckboxColumn(col: GroupsGridColumn): JSX.Element {
    const checkboxChecked = col.checkboxState === CheckboxState.checked;
    const checkboxMixedState = col.checkboxState === CheckboxState.mixed;
    const checkboxDisabled = !col.isCheckboxEnabled;
    const checkboxProps: CheckBoxProps = {
      checked: checkboxChecked,
      handleChange: col.onCheckboxChanged,
      indeterminate: checkboxMixedState,
      testId: GROUPS_GRID_HEADER_CHECKBOX_TEST_ID,
      disabled: checkboxDisabled
    };

    return <>
      <Tooltip
        getContent={() => { return checkboxDisabled ? <></> : this.tooltipContent(col.checkboxState); }}
        position={TooltipPosition.BottomRightCorner}
      >
        <CheckBoxWidget {...checkboxProps} />
      </Tooltip>
    </>;
  }

  public render(): JSX.Element {
    const col: GroupsGridColumn = this.props.col as GroupsGridColumn;
    return this.renderCheckboxColumn(col);
  }
}

const GroupsGridHeaderFormatterFactory = React.createFactory(GroupsGridHeaderFormatter);

export {GroupsGridHeaderFormatterFactory};
